const hyphenatedCurrentLocale = document.documentElement.lang || "en"
const underscoredCurrentLocale = hyphenatedCurrentLocale.replace(/-/g, '_')
const lang = hyphenatedCurrentLocale.split("-")[0]

export { underscoredCurrentLocale, hyphenatedCurrentLocale, lang }